//Validating length
export const validateLength = (text, length) => {
  return text.length > length
}

//validating password
export const validateName= (text, lengthSpecified) => {
  var format = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
  if(format.test(text)) return "Special characters not allowed."
  else if(lengthSpecified && text.length > lengthSpecified ) return `Please limit the characters to ${lengthSpecified}`
  else return "";
}  

//validating email
export const validateEmail = (test) => {   
  const email = test
  const re = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{1,3})$/;
  return re.test(String(email).toLowerCase());
};

//Validating password
export const validatePassword = (password) => {
  const re = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,20}$/;
  return re.test(String(password));
};

export const validateUrl = (test) => {
  const url = test
  const re = /(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]/
  return re.test(String(url).toLowerCase())
}

/// form validator
export const formValidator = (formData, formSchema, excludedKeys) => {
  let data = formData;
  let error = {};
  let valid = {isValid: true}
  for (var key in formSchema){
    if(key === excludedKeys) continue;
    else if(data[key] === undefined || data[key] === "" || data[key] === 0 || data[key] === null) {
      error[key] = "Field cannot be empty"
      valid.isValid = false;
    }
    if (
      formData["start_date"] !== undefined &&
      formData["end_date"] !== undefined
    ) {
      if (formData["start_date"] === formData["end_date"]) {
        error["end_date"] = `Start Date and End Date can't be same`;
        valid.isValid = false;
      }
    }
    if (formData["currently_working_here"] === true) {
      error["end_date"] = null;
      valid.isValid = true;
    }
  }
  return [valid.isValid, error]
}

